export const messages = {
  title: {
    id: 'admin/promotions.form.conditions.first-purchase.title',
  },
  subtitle: {
    id: 'admin/promotions.form.conditions.first-purchase.subtitle',
  },
  editor: {
    radioGroup: {
      id: 'admin/promotions.form.conditions.first-purchase.editor.radio-group',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.first-purchase.view.title',
    },
  },
  login: {
    optional: {
      title: {
        id: 'admin/promotions.form.conditions.first-purchase.login.optional',
      },
      description: {
        id: 'admin/promotions.form.conditions.first-purchase.editor.optional.description',
      },
    },
    required: {
      title: {
        id: 'admin/promotions.form.conditions.first-purchase.login.required',
      },
      description: {
        id: 'admin/promotions.form.conditions.first-purchase.editor.required.description',
      },
    },
  },
}
